/* Commerce JS scoped a product/cart. El form nativo de Shopify ya funciona.
   Ampliar (variant images, ajax cart) cuando exista catálogo de merch. */
(function(){
  var sel = document.querySelector('[data-at-variant]');
  if(!sel) return;
})();
